<template>
  <v-layout fill-height>
    <v-layout v-if="areDetailsShown" fill-height column>
      <v-flex class="pa-3" style="height:100% !important;overflow:auto;">
        <v-layout fill-height column class="px-4 py-2" style="border-radius:16px;border:1px solid lightgray;color:rgba(0,0,0,0.7);overflow-y:auto;">
          <div class="pl-0 pb-0 d-block" style="line-height:normal;font-size:28px;font-weight:600;text-transform:capitalize;">{{ detailedDistributor.distributorName.toLowerCase() }}</div>
          <div class="ml-0 mb-3" style="font-size:12px;">
            Código de distribuidor (1): {{ detailedDistributor.distributorCode1 }}<br>
            Código de distribuidor (2): {{ detailedDistributor.distributorCode2 }}<br>
          </div>
          <!-- <div>
            <div v-if="detailedDistributor.lastLog.length > 0 && enabledCards.length > 0" class="title pb-0">Últimos logs</div>
            <div v-else>
              {{enabledCards.length > 0 ? 'Error lógico' : (detailedDistributor.lastLog.length > 0 ? 'No hay tarjetas activadas' : 'No existen logs') }}
            </div>
            <div
              :key="card.cardType"
              v-for="(card) in enabledCards"
              style="color:#777777;"
            >
              <div class="body-2 mt-2">{{ card.cardName }}</div>
              <div
                :key="index"
                v-for="(logDetail, index) in card.extra.logDetails(detailedDistributor)"
              >
                <span
                  class="caption"
                >{{ logDetail.label }}:</span>
                <template v-if="Array.isArray(logDetail.data(true))">
                  <div :key="index" v-for="(filedata, index) in logDetail.data(true)">
                    {{ filedata }}
                  </div>
                </template>
                <template v-else-if="typeof logDetail.data(true) === 'string'">
                  {{ logDetail.data(true) }}
                </template>
                <template v-else>
                  <log-details :show-all="false"></log-details>
                </template>
              </div>
            </div>
          </div> -->
          <div>
            <div v-if="detailedDistributor.lastLog.length > 0 && enabledCards.length > 0" class="title pb-0">
              <v-layout row wrap>
                <v-flex xs6 sm12 md12 lg6>
                  Últimos logs
                </v-flex>
                <v-flex xs6 sm12 md12 lg6>
                  <v-checkbox
                    hide-details
                    label="Mostrar todo"
                    v-model="showAllLastLog"
                    style="color:#00B4C7 !important;"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </div>
            <div v-else>
              {{enabledCards.length > 0 ? 'Error lógico' : (detailedDistributor.lastLog.length > 0 ? 'No hay tarjetas activadas' : 'No existen logs') }}
            </div>
            <v-data-table
              class="strategio-table-section mt-1 mb-3"
              :items="enabledCardsLogs"
              hide-headers
              hide-actions
              item-key="cardType"
            >
              <template slot="items" slot-scope="props">
                <tr :ref="getHighlightTag(props.item, detailedDistributor, showAllLastLog)" @click="props.expanded = !props.expanded" style="cursor:default;color:gray;">
                  <td style="font-weight:bold;">{{ props.item.cardName }}</td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <v-card flat class="px-4 mt-1" style="max-height:205px;overflow:auto;color:gray;">
                  <div
                    :key="index"
                    v-for="(logDetail, index) in props.item.extra.logDetails(detailedDistributor)"
                    v-if="logDetail.visible"
                  >
                    <span
                      class="caption"
                    >{{ logDetail.label }}:</span>
                    <template v-if="typeof logDetail.data(showAllLastLog) === 'string'">
                      {{ logDetail.data(showAllLastLog) }}
                    </template>
                    <template v-else>
                      <log-details :distributor="detailedDistributor" :card="props.item" :show-all="showAllLastLog"></log-details>
                    </template>
                  </div>
                </v-card>
              </template>
            </v-data-table>
          </div>
        </v-layout>

      </v-flex>
      <div>
        <v-layout fill-height column>
          <v-flex class="mb-2">
            <v-layout text-xs-center>
              <v-flex>
                <v-btn
                  depressed rounded dark
                  class="strategio-card-button mr-0"
                  :style="[{'background-color': (isDistributorConsistencyLogs && showMore) ? '#0099AB' : '#00B4C7'}]"
                  :loading="isLoading"
                  @click="showConsistencyLogs(detailedDistributor)"
                >
                  {{ (isDistributorConsistencyLogs && showMore) ? 'Ocultar cons. logs' : 'Ver cons. logs' }}
                </v-btn>
              </v-flex>
              <v-flex>
                <v-btn
                  depressed rounded dark
                  class="strategio-card-button ml-0"
                  style="background-color:#00B4C7;"
                  :loading="isLoading"
                  @click="showDatabaseLogs(detailedDistributor)"
                >
                  {{ (isDistributorDatabaseLogs && showMore) ? 'Ocultar DB logs' : 'Ver DB logs' }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <transition name="expand">
          <!-- <v-slide-y-reverse-transition> -->
            <v-flex v-show="isDistributorLogs && showMore" class="my-0">
              <v-layout row :wrap="['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)">
                <v-flex xs12 class="px-3 mb-3 order-xs2 order-sm1">
                  <v-layout>
                    <v-data-table
                      class="strategio-table-section"
                      v-show="isDistributorConsistencyLogs"
                      :headers="headers"
                      :items="dataTableLogs.logs"
                      hide-headers
                      hide-actions
                      :pagination.sync="pagination"
                      item-key="logDate"
                    >
                      <!-- :rows-per-page-items="rowsPerPageItems" -->
                      <template slot="items" slot-scope="props">
                        <tr
                          @click="props.expanded = !props.expanded"
                          :style="[{'cursor': logsWithNoErrors(props.item.log || []) ? 'default' : 'pointer'}, {'color': logsWithNoErrors(props.item.log || []) ? 'darkgray' : '#777777'}]"
                        >
                          <td>{{ props.item.logDate }}  ({{ props.item.logDateFromNow }}) <span style="color:#777777;font-weight:bold;">{{logsWithNoErrors(props.item.log || []) ? ' - sin prob.' : ''}}</span></td>
                        </tr>
                      </template>
                      <template slot="expand" slot-scope="props">
                        <v-card flat class="px-4 mt-1" style="max-height:287px;overflow:auto;color:#777777;">
                          <template v-for="(log, logIndex) in props.item.log" v-if="errorsInLog(log)">
                            <template v-if="log.fileName">
                              Nombre de archivo: {{ log.fileName }}
                              <ul class="ml-4 pb-1" :key="`${log.fileName}.${logIndex}`"
                                style="font-size:12px;font-weight:300;"
                              >
                                <li>Filas removidas: {{ (log.totalLinesInput - log.totalLinesOutput) > 0 ? (log.totalLinesInput - log.totalLinesOutput) + ' filas' : 'Ninguna' }}</li>
                                <li>Filas con columnas disparejas: {{ log.linesNotMatchingColumns.length }}</li>
                                <li>Filas con problemas en datos: {{ log.linesWithColumnsIssues.length }}</li>
                                <li>Filas con tipos de datos incorrectos: {{ log.linesWithNotMatchingType.length }}</li>
                              </ul>
                            </template>
                            <!-- v-if="false && ..." para que no se muestren como se pidió -->
                            <template v-else-if="true && log.error">
                              <div :key="`${log.filename}.${logIndex}`">
                                <div>
                                  Nombre de archivo: {{ log.error ? log.error.match(/\s(\w+.txt)\s/)[1].slice(0,2) : 'Sin nombre. Error no definido' }}
                                </div>
                                <div>
                                  {{ log.error }}
                                </div>
                              </div>
                              <v-divider :key="logIndex" v-if="logIndex + 1 < detailedDistributor.lastLog.length"></v-divider>
                            </template>
                          </template>
                        </v-card>
                      </template>
                    </v-data-table>
                    <v-data-table
                      class="strategio-table-section"
                      v-show="isDistributorDatabaseLogs"
                      :headers="headers"
                      :items="dataTableLogs.logs"
                      hide-headers
                      hide-actions
                      :pagination.sync="pagination"
                      item-key="registerDate"
                    >
                      <template slot="items" slot-scope="props">
                        <tr @click="props.expanded = !props.expanded" style="cursor:pointer;color:gray;">
                          <td>{{ props.item.registerDate }} ({{ props.item.registerDateFromNow }})</td>
                        </tr>
                      </template>
                      <template slot="expand" slot-scope="props">
                        <v-card flat class="px-4 mt-1" style="max-height:287px;overflow:auto;color:gray;">
                          Nombre de tabla: {{ props.item.salesTableName }}
                          <ul class="ml-5 mb-1"
                            style="font-size:12px;font-weight:300;"
                          >
                            <li>Ventas desactualizadas: {{ props.item.isMaxDateOutdated ? 'Sí' : 'No' }}</li>
                            <li>Fecha supuesta de última venta: {{ props.item.maxDate.split(' ')[0] }}</li>
                            <li>Tiempo supuesto desde última venta: {{ props.item.maxDateFromNow }}</li>
                            <li>Registros desactualizados: {{ props.item.isRegisterDateOutdated ? 'Sí' : 'No' }}</li>
                          </ul>
                        </v-card>
                      </template>
                    </v-data-table>

                  </v-layout>

                </v-flex>
                <v-flex
                  v-if="renderPag"
                  v-show="dataTableLogs"
                  class="pr-2 order-sm2"
                >
                  <v-layout fill-height justify-end align-end>
                    <v-pagination
                      v-model="pagination.page"
                      :total-visible="5"
                      :length="pages"
                      class="strategio-pagination-component logs"
                    ></v-pagination>

                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          <!-- </v-slide-y-reverse-transition> -->
          </transition>
        </v-layout>

      </div>
    </v-layout>
    <v-container v-else>
      <v-layout wrap>
        <v-flex style="color:rgba(0,0,0,.38)" class="align-center layout">
          Seleccione una distribuidora
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
import {find, filter, isEmpty} from 'lodash'

import logsStorage from '../../storage/logsStorage'
import cardsStorage from './../../storage/cardsStorage'

export default {
  data () {
    return {
      renderPag: false,
      cards: {},
      showMore: false,
      dataTableLogs: {},
      consistencyLogs: [],
      databaseLogs: [],
      headers: [],
      selected: [],
      pagination: {
        rowsPerPage: 4
      },
      isLoadingConsistencyLogs: false,
      isLoadingDatabaseLogs: false,

      showAllLastLog: false
    }
  },
  mounted () {
    this.cards = cardsStorage.getCardsPointer().cards
    this.consistencyLogs = logsStorage.getConsistencyLogsPointer()
    this.databaseLogs = logsStorage.getDatabaseLogsPointer()
  },
  watch: {
    showAllLastLog (val) {
      val && Object.values(this.$refs).forEach((i) => { i.classList.remove('strategio-highlighting'); setTimeout(() => { i.classList.add('strategio-highlighting') }, 0) })
    }
  },
  methods: {
    getHighlightTag (card, distributor, showAll) {
      return card.extra.logDetails(distributor).reduce((t, i) => t && (typeof i.data(showAll) === 'string' || !i.highlightable), true) ? null : `highlight-${card.cardType}`
    },
    showConsistencyLogs (distributor) {
      if (this.isDistributorConsistencyLogs) {
        this.renderPag = true
        this.showMore = !this.showMore
        return
      }
      this.isLoadingConsistencyLogs = true
      logsStorage.getConsistencyLogs({
        data: {
          distributorCode2: distributor.distributorCode2
        },
        onSuccess: (consistencyLogs) => {
          this.dataTableLogs = find(this.consistencyLogs, (item) => {
            return item.distributorCode2 === distributor.distributorCode2
          })

          this.showMore = true

          this.isLoadingConsistencyLogs = false
          this.renderPag = true
        },
        onError: () => {
          this.isLoadingConsistencyLogs = false
        }
      })
    },
    showDatabaseLogs (distributor) {
      if (this.isDistributorDatabaseLogs) {
        this.renderPag = true
        this.showMore = !this.showMore
        return
      }
      this.isLoadingDatabaseLogs = true
      logsStorage.getDatabaseLogs({
        data: {
          distributorCode1: distributor.distributorCode1
        },
        onSuccess: (databaseLogs) => {
          this.dataTableLogs = find(this.databaseLogs, (item) => {
            return item.distributorCode1 === distributor.distributorCode1
          })

          this.showMore = true

          this.isLoadingDatabaseLogs = false
          this.renderPag = true
        },
        onError: () => {
          this.isLoadingDatabaseLogs = false
        }
      })
    },
    logsWithNoErrors (dayLogs) {
      return dayLogs.reduce((t, i) => t && !this.errorsInLog(i), true)
    },
    errorsInLog (log) {
      return (
        (log.linesNotMatchingColumns || []).length +
        (log.linesWithColumnsIssues || []).length +
        (log.linesWithNotMatchingType || []).length
      ) > 0
    }
  },
  computed: {
    enabledCards () {
      return filter(this.cards, 'enabled')
    },
    enabledCardsLogs () {
      return filter(this.enabledCards, i => i.extra.enabled)
    },
    areDetailsShown () {
      let temp = !isEmpty(this.detailedDistributor)
      if (temp === false) {
        this.renderPag = false
        this.showMore = false // Necesario para que paginador no se muestre vacío
      }
      return temp
    },
    isDistributorLogs () {
      let temp = this.isDistributorConsistencyLogs || this.isDistributorDatabaseLogs
      if (temp === true) {
        // this.renderPag = true // Ocurre lo mismo, se ha movido al lugar correcto
        this.pagination.page = 1
      }
      return temp
    },
    isDistributorConsistencyLogs () {
      let temp = this.dataTableLogs.distributorCode2 === this.detailedDistributor.distributorCode2 &&
        this.dataTableLogs.logType === 'CONSISTENCY'
      return temp
    },
    isDistributorDatabaseLogs () {
      let temp = this.dataTableLogs.distributorCode1 === this.detailedDistributor.distributorCode1 &&
        this.dataTableLogs.logType === 'DATABASE'
      return temp
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 1

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    /* pages () {
      return this.pagination.rowsPerPage ? Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage) : 0
    }, */
    isLoading () {
      return this.isLoadingConsistencyLogs || this.isLoadingDatabaseLogs
    }
  },
  props: {
    detailedDistributor: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style scoped>
/* Se ha tomado 551px como max-height por que ese es el valor máximo que se ha encontrado */
/* Confirmar si valores son parecidos  */
.expand-enter-active {
  transition: max-height .5s ease-in;
  max-height: 551px;
  padding: 0;
  overflow: hidden;
}
.expand-leave-active {
  transition: max-height .3s ease-out;
  max-height: 0;
  padding: 0;
  overflow: hidden;
}
.expand-enter {
  max-height: 0;
  padding: 0;
  opacity: 0;
}
.expand-leave {
  max-height: 551px;
  padding: 0;
  opacity: 0;
}

@keyframes strategio_highlight_animation {
  0% {
    background: #00B3C756;
  }
  100% {
    background: none;
  }
}

.strategio-highlighting {
  animation: strategio_highlight_animation 2s;
}

</style>



// WEBPACK FOOTER //
// src/components/logs/distributor-details-log-report.vue